export default {"src":"/_next/static/media/X-Twitter.f5c4b0ed.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};